// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"ohUao7dc","loader":"oTKIM0Rn","toggleCell":"GvqKYDDT"};